/**
 * Detect invalid buyer filter combinations for SEO noindex + safe UX (M18).
 */
import { parseVehicleSearchParams } from "./vehicleSearchParamsUrl";

/**
 * @param {import('../../constants/vehicleSearchParamsConstants').VehicleSearchParams|object} params
 */
export function hasInvalidVehicleSearchFilterCombo(params = {}) {
  const p = parseVehicleSearchParams(params);

  if (p.model && !p.make) return true;

  if (p.yearMin != null && p.yearMax != null && p.yearMin > p.yearMax) return true;
  if (p.priceMinCop != null && p.priceMaxCop != null && p.priceMinCop > p.priceMaxCop) {
    return true;
  }
  if (p.mileageMinKm != null && p.mileageMaxKm != null && p.mileageMinKm > p.mileageMaxKm) {
    return true;
  }

  return false;
}
